module.exports = __webpack_public_path__ + "img/434240_D3D3CF_898784_A4A49F-256px.7c3df2c3.png";